import React, {Component} from 'react';
import '../tools/css/BtnDelete.css';


//Componente para boton Delete

class BtnDelete extends Component {


      render(){

          const { title } = this.props;

       return (

          <div >

              <button className="btn btn-delete" title={title || "Eliminar"}>
                <i className="fas fa-times"></i>
              </button>

          </div>

      )

    }

  }


  export default BtnDelete;